#= require turbolinks
$(document).on "turbolinks:load", ->
  uncheck_all = (elements) ->
    elements.each ->
      if this.checked
        this.checked = false
  set_copy_to_clipboard = () ->
    $("#copy-to-clipboard").on 'click', (e) ->
      e.preventDefault()
      targetID = "#" + "#{e.currentTarget.id}"

      if navigator.clipboard?
        navigator.clipboard.writeText($(targetID).text())
          .then ->
            $(targetID)
              .attr('data-bs-original-title', '✓ Copied to clipboard!')
              .tooltip('show')

        setTimeout ->
          $(targetID)
            .attr('data-bs-original-title', 'Click to copy')
            .tooltip('hide')
        , 2000
      else
        console.error("Clipboard API not supported.")

  loadLmsIntegration = (e) ->
    $.ajax
      url: $(e.currentTarget).data("url")
      method: "GET"
      dataType: "html"
      success: (response) ->
        $("#lms-integration").html(response)
        Rails.fire(document, 'turbolinks:load')
      error: (xhr, status, error) ->
        console.error("AJAX Error:", status, error)

  $(".filter-row.view-selected td:nth-child(3)").addClass("text-muted")
  $(".filter-row.view-selected").removeClass('view-selected')

  $(".unlink-course-button").on('click', (e) ->
    wasCourseSelected = false
    $(".linked-course").each ->
      if this.checked
        wasCourseSelected = true
        $('.unlink-popup-courseware-course').text(this.dataset.coursewareCourseName)
        $('.unlink-popup-lms-course').text(this.dataset.lmsCourseName)
        $('.unlink-popup-lms-type').text(this.dataset.lmsType)
    if !wasCourseSelected
      alert("You didn't select any courses to unlink.")
      return false
  )

  $("#confirm-popup-cancel").on('click', (e) ->
    uncheck_all($(".linked-course"))
  )

  $(".lms-integration-tabs__button").on 'click', (e) ->
    e.preventDefault()
    loadLmsIntegration(e)


  $(".lms-integration-body_cards__card_anchor").on 'click', (e) ->
    e.preventDefault()
    loadLmsIntegration(e)


  $("#unlink_lms_interest").on 'click', (e) ->
    target = $(e.currentTarget).data('bs-target')
    $(target).find('#lms_confirm_delete_interest').html($(e.currentTarget).data('lms'))
    $(target).find('.modal-confirm-submit').attr('href', $(e.currentTarget).data('href'))
    $(target).find('.modal-confirm-submit').attr('data-method', 'delete')
    $(target).modal('show')

  set_copy_to_clipboard()